module.exports = __webpack_public_path__ + "img/KC.aa73cfd0.png";